import { ReactNode } from "react";

import { FetchError } from "common/fetch/types";

import TextButton from "client/common/components/buttons/TextButton";
import Alert from "client/common/components/content/Alert";
import { urls } from "client/routes";
import { LoginErrorData, LoginErrorKind } from "client/accounts/types";

import styles from "../../styles/LoginErrorAlert.module.less";

type LoginErrorAlertProps = {
  error: FetchError<{}, LoginErrorData>;
};

type ErrorAlertContent = { title: string; description: ReactNode };

const LoginErrorAlert = ({ error }: LoginErrorAlertProps) => {
  const statusToAlertProps: Record<LoginErrorKind, ErrorAlertContent> = {
    [LoginErrorKind.NoUser]: {
      title: "No user found with that information.",
      description: (
        <>
          If this is your first time logging in to our new online store, please{" "}
          <TextButton hasUnderline={true} dest={urls.accounts.signup()}>
            sign up
          </TextButton>{" "}
          first.
        </>
      ),
    },
    // TODO: update the below for email auth
    [LoginErrorKind.InvalidUsername]: {
      title: "Username is not a valid phone number.",
      description: <>Please try again.</>,
    },
    [LoginErrorKind.InvalidPassword]: {
      title: "Password is not valid.",
      description: <>Please try again.</>,
    },
    [LoginErrorKind.AttachedToOtherAcct]: {
      title:
        "This phone number is attached to an account that uses a different phone number to log in.",
      description: <>Please try again with your primary phone number.</>,
    },
    [LoginErrorKind.WrongPassword]: {
      title: "Incorrect password.",
      description: <>Please try again or reset your password.</>,
    },
    [LoginErrorKind.UsernameShouldBeEmail]: {
      title: "Incorrect username.",
      description: <>This account uses an email address. Please sign in with your email.</>,
    },
    [LoginErrorKind.UsernameShouldBeNumber]: {
      title: "Incorrect username.",
      description: <>This account uses a phone number. Please sign in with your mobile number.</>,
    },
  };

  const content = error.data?.kind && statusToAlertProps[error.data.kind];
  const title = content ? content.title : error?.detail;
  const description = content?.description;

  return (
    <div>
      <Alert variant="danger">
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{description}</div>
        </div>
      </Alert>
    </div>
  );
};

export default LoginErrorAlert;
